'use client';

import { useState, useEffect } from 'react';
import { Download, CheckCircle, Star } from 'lucide-react';
import logo from './logo.png';

export default function EBandhanDownload() {
    const [downloadCount, setDownloadCount] = useState(12847);

    useEffect(() => {
        // Simulate download count increment
        const interval = setInterval(() => {
            setDownloadCount((prev) => prev + Math.floor(Math.random() * 3));
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const handleDownload = () => {
        // Trigger the APK download
        console.log('Downloading E-Bandhan APK...');
        const link = document.createElement('a');
        link.href = '/e-bandhan-v2.4.apk';
        link.download = 'e-bandhan-v2.4.apk';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="landing-container">
            {/* Animated Background Elements */}
            <div className="bg-element-1"></div>
            <div className="bg-element-2"></div>
            <div className="bg-element-3"></div>

            {/* Floating particles */}
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>
            <div className="particle"></div>

            {/* Header */}
            <header className="header">
                <div className="app-icon">
                    <img src={logo} alt="E-Bandhan Logo" className="app-logo" />
                </div>
                <h1 className="app-title">E-Bandhan</h1>
                <p className="app-description">
                A Directory of Comilla Victoria Govt. College, Cumilla.

                </p>
            </header>

            {/* Main Download Section */}
            <div className="download-section">
                <div className="download-card">
                    <div className="download-icon-container">
                        <Download />
                    </div>
                    <h2 className="download-title">Download APK</h2>
                    <p className="version-info">Latest Version 2.4 • 48.9 MB</p>

                    <div className="rating-container">
                        <div className="stars">
                            <Star />
                            <Star />
                            <Star />
                            <Star />
                            <Star />
                        </div>
                        <span className="rating-text">4.8 (120+ reviews)</span>
                    </div>

                    <button onClick={handleDownload} className="download-button">
                        <Download />
                        Download E-Bandhan APK
                    </button>

                    <div className="download-stats">
                        <CheckCircle />
                        <span>{downloadCount.toLocaleString()}+ downloads</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
